import styled from 'styled-components';
import { connect } from 'react-redux';
import { calcColumnWidthPercentage } from '../../../styles/units';

const ColumnBlock = styled.div`
  //position: relative;
  display: flex;
  ${props =>
    props.alignBottom &&
    props.breakpoint === 'desktop' &&
    `
    align-items: flex-end;
    padding-top: 23.5rem;
  `} ${props =>
  props.flex &&
  `
    flex-wrap: wrap;
  `};

  ${props =>
    props.block &&
    `
    display: block;
  `} ${props =>
  (props.columns === 1 || props.breakpoint === 'phone') &&
  `
    flex-direction: column;
  `} ${props =>
  props.breakpoint !== 'phone'
    ? `width: ${calcColumnWidthPercentage(props.columns, props.parentColumns)};`
    : `width: 100%;`}};
`;

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

const ConnectedColumnBlock = connect(mapStateToProps, null)(ColumnBlock);

export default ConnectedColumnBlock;



// WEBPACK FOOTER //
// ./src/modules/layout/components/ColumnBlock.js